import {
  ADVISOR_SET_REGION,
  ADVISOR_SET_SPORT_TYPE,
  ADVISOR_SET_SPORT_VARIANT,
  ADVISOR_UNSET_SPORT_VARIANT,
  ADVISOR_SET_PARAMETERS
} from "../../store/constants/hwk";

export function setRegion(region) {
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch({ type: ADVISOR_SET_REGION, region });
      resolve(true);
    });
}

export function setSportType(sportType) {
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(unsetSportVariant());
      dispatch({ type: ADVISOR_SET_SPORT_TYPE, sportType });
      resolve(true);
    });
}

export function setSportVariant(sportVariant) {
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch({ type: ADVISOR_SET_SPORT_VARIANT, sportVariant });
      resolve(true);
    });
}

export function unsetSportVariant() {
  return {
    type: ADVISOR_UNSET_SPORT_VARIANT,
  };
}

export function setParameters(parameters) {
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch({ type: ADVISOR_SET_PARAMETERS, parameters });
      resolve(true);
    });
}
